module.exports = __webpack_public_path__ + "img/arrow_back.de0bcf1d.svg";